import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Agent from '../views/Agent.vue'
import Team from '../views/Team.vue'
import Landing from '../views/Landing.vue'
import UpdatePassword from '../views/UpdatePassword.vue'
import ProfileSetup from '../views/ProfileSetup.vue'
import Summary from '../views/Summary.vue'
import PaymentOption from '../views/PaymentOption.vue'

Vue.use(VueRouter).vue

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/register',
    name: 'Agent',
    component: Agent
  },
  {
    path: '/registerTeam',
    name: 'Team',
    component: Team
  },
  {
    path: '/demo',
    name: 'Home',
    component: Home
  },
  {
    path: '/setupAccount/:code',
    name: 'UpdatePassword',
    component: UpdatePassword
  },
  {
    path: '/setupProfile/:personId',
    name: 'ProfileSetup',
    component: ProfileSetup
  },
  {
    path: '/payment-option/:personId',
    name: 'PaymentOption',
    component: PaymentOption
  },
  {
    path: '/summary',
    name: 'Summary',
    component: Summary
  }
]

const router = new VueRouter({
    routes: routes
})

router.afterEach((to, from) => {
	console.log('fullPath', to.fullPath);
	if(to.fullPath != '/'){
		window.parent.postMessage({message: 'changeRoute::'+  to.fullPath}, '*');
	}
    if (to.name=='Landing') {
        document.getElementById('app').classList.remove('container', 'main-wrapper')
        // document.getElementById('app').classList.remove('main-wrapper')
        document.getElementById('logo_wrap') && document.getElementById('logo_wrap').classList.add('hide')
    }else {
        document.getElementById('app').classList.add('container', 'main-wrapper')
        // document.getElementById('app').classList.add('main-wrapper')
        document.getElementById('logo_wrap') && document.getElementById('logo_wrap').classList.remove('hide')

    }
})
export default router
